<template>
  <div class="diagram-status-label">
    <label
      v-for="(status,statusIndex) in statusItems"
      :key="statusIndex"
      class="diagram-status-label__status-item"
      :class="[{checked:$_statusCheck(status.value)}]"
    >
      <div
        class="diagram-status-label__status-item__block"
        :style="{backgroundColor:$_statusColor(status),width:`${labelWidth}px`,height:`${labelHeight}px`,borderRadius:`${labelRadius}px`}"
      />
      <input
        v-model="checkedValue"
        type="checkbox"
        :value="status.value"
        @change="$_checkboxOnchange()"
      >
      <p class="diagram-status-label__status-item__text">{{ status.text }}</p>
    </label>
  </div>
</template>
<script>
export default {
  name: "DiagramStatusLabel",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    statusItems: {
      type: Array,
      default() {
        return [];
      },
    },
    labelWidth: {
      type: Number,
      default: 0,
    },
    labelHeight: {
      type: Number,
      default: 0,
    },
    labelRadius: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    checked_proxy: null,
  }),
  computed: {
    checkedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.checked_proxy = val;
      },
    },
  },
  methods: {
    $_statusCheck(status) {
      let check = false;
      for (let i = 0; i < this.value.length; i++) {
        const itemsCheckedItem = this.value[i];
        if (itemsCheckedItem == status) {
          check = true;
        }
      }
      return check;
    },
    $_statusColor(status) {
      let checked = this.$_statusCheck(status.value);
      return checked ? status.color : status.disabledColor;
    },
    $_checkboxOnchange() {
      this.$emit("input", this.checked_proxy);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-status-label";
</style>